var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.72021C8.66666 2.72021 2.66666 8.70688 2.66666 16.0802C2.66666 22.7469 7.54666 28.2802 13.92 29.2802V19.9469H10.5333V16.0802H13.92V13.1335C13.92 9.78688 15.9067 7.94688 18.96 7.94688C20.4133 7.94688 21.9333 8.20022 21.9333 8.20022V11.4935H20.2533C18.6 11.4935 18.08 12.5202 18.08 13.5735V16.0802H21.7867L21.1867 19.9469H18.08V29.2802C21.2219 28.784 24.0829 27.1809 26.1466 24.7603C28.2102 22.3397 29.3405 19.2611 29.3333 16.0802C29.3333 8.70688 23.3333 2.72021 16 2.72021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.015818a6c3543258886bc6eb59c47338.svg";
export { ForwardRef as ReactComponent };